import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

export type CoveragesStore = {
  coverageId: string
  coverageName: string
  coverageDescription: string
  asfBranchCode: string
  order: number
}

export type Coverages = {
  [key: string]: CoveragesStore[] | null
}

type Store = {
  coverages: Coverages | null
  setCoverages: (coverages: Coverages) => void
  resetCoverages: () => void
}

export const useCoveragesStore = create<Store>()(
  devtools(
    (set, get) => ({
      coverages: null,
      setCoverages: (coverages) =>
        set(() => {
          const newData = {
            ...get().coverages,
            ...coverages,
          }

          return { coverages: newData }
        }),
      resetCoverages: () => set({ coverages: null }),
    }),
    { name: 'CoveragesStore' },
  ),
)
